import {useApiQuery} from 'src/hooks/useApiQuery';
import type {DashboardDetail} from 'src/types/byod';
import {BYOD_API_BASE as BASE} from 'src/components/analytics-genesis/byod/api';
import {byodQueryDefaults} from 'src/components/analytics-genesis/byod/api/error-handling';


export function useLoadDashboard(dashboardId: string | null) {
  return useApiQuery<DashboardDetail>(
    dashboardId
      ? {pathname: `${BASE}/dashboards/${encodeURIComponent(dashboardId)}`}
      : null,
    {
      queryOptions: {
        ...byodQueryDefaults,
        queryKey: ['byod-dashboard', dashboardId],
        enabled: Boolean(dashboardId),
        // Always fetch fresh — do NOT cache the layout. The store is the source
        // of truth during a session, and caching fights the builder's onEnter
        // reset(). Concretely: the builder mounts inside <OnEnter callback={reset}>
        // and React fires child effects before parent effects — so a synchronous
        // cache hit lets the builder's hydrate run BEFORE onEnter's reset() wipes
        // the store, leaving an empty canvas (repro: open a dashboard in the
        // embed to warm this cache, then navigate to /byod/dashboard/:id — it
        // rendered empty). Fetching fresh keeps `dashboardData` undefined until
        // after the reset, so hydrate always lands last and wins. Do not raise
        // staleTime/gcTime here without also relocating that reset.
        staleTime: 0,
        gcTime: 0,
        // Don't refetch on window focus — builder store is source of truth
        // for the session; background refetches would not re-seed anyway
        // but this avoids unnecessary network calls.
        refetchOnWindowFocus: false,
      },
    },
  );
}
